import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { Empty, Pagination, Spinner } from "ui-components";

import { JobsCard } from "@/src/app/[locale]/(public)/jobs/components/JobCard";
import { Filters } from "@/src/app/[locale]/(public)/jobs/enums/filter.enum";
import {
  UserFavouriteJobResponse,
  useJobGetFavourites,
} from "@/src/hooks/api/generated";
import { useNavigate } from "@/src/hooks/useNavigate";

export default function MySavedJobs(): JSX.Element {
  const searchParams = useSearchParams();
  const { mutate: getJobs, status } = useJobGetFavourites();
  const page = searchParams.get(Filters.page);
  const [jobsData, setJobsData] = useState<UserFavouriteJobResponse>();
  const { pushQueryParam } = useNavigate();

  useEffect(() => {
    getJobs(
      {
        data: {
          page: page ? parseInt(page) : 1,
          pageSize: 9,
        },
      },
      {
        onSuccess: (data) => {
          setJobsData(data);
        },
      }
    );
  }, [getJobs, page]);

  return (
    <div>
      {jobsData?.data.length === 0 && <Empty text="No saved jobs." />}
      {status === "pending" && page === "1" && !jobsData?.data.length && (
        <div className="flex flex-col items-center gap-5">
          <Spinner size="lg" intent="brand-primary" />
        </div>
      )}
      <div className="flex flex-wrap justify-start items-center -mx-2.5">
        {jobsData?.data.map(({ job }) => {
          const bannerImage = job.organization.organizationImage.find(
            (img) => img?.image?.type === "banner"
          )?.image?.public_id;

          const logoImage = job.organization.organizationImage.find(
            (img) => img?.image?.type === "logo"
          )?.image?.public_id;
          return (
            <div key={job.id} className="w-full sm:w-1/2 md:w-1/3 p-2.5">
              <JobsCard
                city={job.locations.location}
                country={job.locations.country}
                type={job.type}
                coverImageUrl={bannerImage}
                logoImageUrl={logoImage}
                organizationName={job?.organization?.name}
                organizationSlug={job?.organization?.slug}
                key={job.id}
                id={job.id}
                title={job.title}
                industry={job?.organization?.industry?.name}
                jobSlug={job.slug}
                sub_brand_name={job.sub_brand_name}
                subBrand={job.subBrand}
                isFavorite
                onToggleFavorite={() => {
                  getJobs(
                    {
                      data: {
                        page: page ? parseInt(page) : 1,
                        pageSize: 9,
                      },
                    },
                    {
                      onSuccess: (data) => {
                        setJobsData(data);
                      },
                    }
                  );
                }}
              />
            </div>
          );
        })}
      </div>
      {!!jobsData?.total && jobsData?.total > 0 && (
        <div className="mt-5">
          <Pagination
            currentPage={page ? parseInt(page) : 1}
            totalPages={Math.ceil((jobsData?.total ?? 0) / 9)}
            totalRecords={jobsData?.total ?? 0}
            onPageChange={(newPageNumber) => {
              pushQueryParam({
                key: Filters.page,
                value: newPageNumber.toString(),
              });
            }}
          />
        </div>
      )}
    </div>
  );
}
